type FinalizationStatus = 'CANNOT_BE_FINALIZED' | 'NOT_READY_TO_FINALIZE' | 'READY_TO_FINALIZE';
export function convertIsFinalizable(isFinalizable?: boolean): FinalizationStatus {
    if (isFinalizable == null) {
        return 'NOT_READY_TO_FINALIZE';
    }
    if (!isFinalizable) {
        return 'CANNOT_BE_FINALIZED';
    }
    return 'READY_TO_FINALIZE';
}
